import React from "react";
import ReactDOM from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import "./styles.css";

import { Daily } from "./routes/Daily";
import { Hide } from "./routes/Hide";
import { HowToPlay } from "./routes/HowToPlay";
import { Landing } from "./routes/Landing";
import { ResultScreen } from "./routes/ResultScreen";
import { Seek } from "./routes/Seek";
import { Stats } from "./routes/Stats";

const router = createBrowserRouter([
  { path: "/", element: <Landing /> },
  { path: "/hide", element: <Hide /> },
  { path: "/p/:pinId", element: <Seek /> },
  { path: "/p/:pinId/result", element: <ResultScreen /> },
  { path: "/daily", element: <Daily /> },
  { path: "/pin/:pinId/stats", element: <Stats /> },
  { path: "/how-to-play", element: <HowToPlay /> },
  { path: "*", element: <NotFound /> },
]);

function NotFound() {
  return (
    <div className="page">
      <h1>Nothing here.</h1>
      <p>
        <a href="/">Back to the start</a>
      </p>
    </div>
  );
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>,
);
